/* eslint-disable */
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';
import api from '@/services/api';
import * as xlsx from 'xlsx';

export default {
  async prepararExcel() {
    const { data } = await api.get('/produto/excel');

    return data;
  },
  async fetchProdutos(context, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    context.dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/produto', { params });
    context.commit('SET_LISTA_PRODUTOS', response.data.data);
    context.commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    context.dispatch('toggleLoading', false, { root: true });
  },

  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },

  async splitLastOccurrence(context, payload) {
    const { str, substring } = payload;
    const lastIndex = str.lastIndexOf(substring);
    const before = str.slice(0, lastIndex);
    const after = str.slice(lastIndex + 1);
    return [before, after];
  },

  async salvarProdutoNCM(context, payload) {
    for (let index = 0; index < payload.empresa.length; index++) {
      const empresa = payload.empresa[index];
      const primeiroSplit = await context.dispatch('splitLastOccurrence', { str: empresa, substring:'-' });
      const codPessoa = primeiroSplit[1];
      const segundoSplit = await context.dispatch('splitLastOccurrence', { str: primeiroSplit[0], substring:'-' });
      const nomeCliente = segundoSplit[0];
      const empresaCNPJ = segundoSplit[1];
      let novoProduto = {
        ncm: payload.NCM,
        ncmSeq: payload.NCM_SEQ,
        unidadeMedida: payload.UNIDADE_MEDIDA,
        moeda: payload.MOEDA,
        codigoCliente: payload.CODIGO_PRODUTO.toString(),
        produto: payload.NOME_PRODUTO,
        descricao: payload.DESCRICAO,
        codigoTrust: payload.CODIGO_TRUST,
        empresa: empresaCNPJ.trim(),
        codPessoa: codPessoa.trim(),
        nomeCliente: nomeCliente.trim(),
        quantidade: payload.QUANTIDADE,
        valorUnitario: payload.VALOR_UNITARIO,
        fornecedor: '',
        produtor: ''
      };
      await api.post('/produto/', {
        ...novoProduto,
      });
    }
  },
  async updateProduto(context, payload) {
    delete payload.valorTotal;
    const idUpdate = payload.id
    delete payload.id;
    const object = {
      ...payload,
      empresa: String(payload.empresa[0]).trim(),
    }
    const request = await api.put(`/produto/${idUpdate}`, {
      ...object,
    });
    return request.status;
  },
  async salvarProduto(context, payload) {
      for (let index = 0; index < payload.empresa.length; index++) {
        const empresa = payload.empresa[index];
        const arrEmpresa = empresa.split('-');
        let novoProduto = {
          ...payload,
          empresa: arrEmpresa[1].trim(),
          codPessoa: arrEmpresa[2].trim(),
          nomeCliente: arrEmpresa[0],
        };
        const request =  await api.post('/produto/', {
          ...novoProduto,
        });
        return request.status;
      }
  },
  async deletarProduto(context, payload) {
    if (payload) {
      await api.delete(`/produto/${payload}`);
    }
  },
  carregarTemplateCadastrarProdutos({ commit }, arquivo) {
    if (!arquivo) {
      return;
    }

    const pos = arquivo.name.lastIndexOf('.');
    const extensao = arquivo.name.slice(pos + 1);

    if (!['xlsx', 'csv', 'xls'].includes(extensao)) {
      Vue.$toast.error(Vuetify.framework.lang.t('$vuetify.arquivoNaoSuportado'));

      return;
    }

    const reader = new FileReader();

    reader.readAsArrayBuffer(arquivo);
    reader.onload = () => {
      const data = new Uint8Array(reader.result);
      const workbook = xlsx.read(data, { type: 'array' });
      const folhaGeral = workbook.Sheets[workbook.SheetNames[0]];

      const popular = (campos, folha, linha) => {
        const output = {};

        for (let i = 0; i < campos.length; i++) {
          const campo = campos[i];
          const ref = xlsx.utils.encode_cell({ c: i, r: linha});
          const cell = folha[ref];

          if (typeof campo === 'string') {
            output[campos[i]] = cell?.v?.toString().trim() || null;
          }

          if (typeof campo === 'object' && campo.type === Number) {
            output[campos[i].campo] = cell?.v || null;
          }
        }

        return output;
      }

      const payload = popular([
        'ncm',
        'ncmSeq',
        'produto',
        'descricao',
        'unidadeMedida',
        'moeda',
        'nomeCliente',
        'fornecedor',
        'produtor',
      ], folhaGeral, 1);

      commit('SET_PRODUTO', payload);
    }
  },
};
